export default __webpack_public_path__ + "static/media/perfect.54f2a613.png";